import { useStateUrlParamsArray } from "@common/hooks/useStateUrlParams";
import { useTranslation } from "@localization/useTranslation";
import { InternalAssessmentReportTableProps } from "../InternalAssessmentReportTable.types";
import { useInternalAssessmentReportRows } from "../InternalAssessmentReportTable.hooks";
import { filterBySelection, toSelectOptions } from "@common/components/managementReport/managementReportFilters";

export default function useInternalAssessmentReportExcludedAssessments(props: InternalAssessmentReportTableProps) {
    const { translateLegalEntityAuditStatus } = useTranslation();

    const [searchedExclusionReason, setSearchedExclusionReason] = useStateUrlParamsArray("exclusionReason", []);

    const rows = useInternalAssessmentReportRows(props.assessments);

    const exclusionReasonFilterOptions = toSelectOptions(
        rows.map((row) => ({ id: row.status.toString(), name: translateLegalEntityAuditStatus(row.status.toString()) }))
    );

    return {
        rows: filterBySelection(rows, searchedExclusionReason, (row) => row.status.toString()),
        searchedExclusionReason,
        setSearchedExclusionReason,
        exclusionReasonFilterOptions,
    };
}
